module.exports = __webpack_public_path__ + "73f29e78c2522090f43dd448ed3683ad.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/moonb.woff
// module id = 134
// module chunks = 0